(function($) {
  'use strict';

  const gallery = {
    dom: function() {
      this.$gallery = $('[data-gallery]');
    },

    init: function() {
      const _ = this;

      _.$gallery.each(function() {
        let $this = $(this);
        $this.slick({
          infinite: true,
          arrows: true,
          dots: false,
          slidesToShow: 1,
          fade: true,
          responsive: [
            {
              breakpoint: jcms.breakpoints.fluid,
              settings: {
                centerMode: true,
                centerPadding: 'var(--gutter)',
                dots: true,
                arrows: false,
                fade: false
              }
            }
          ]
        });
      });
    },

    ready: function() {
      this.dom();
      this.init();
    }
  };

  $(function() { gallery.ready(); });

})(jQuery);
